import { computed } from 'vue'
import { formatLocationForTitle } from '~/utils/formatters'

export default function useTitleGenerator(
  filters: FilterOptions,
  companyName: Ref<string>,
  stateFullName: Ref<string>,
  locationDisplay: Ref<string>,
  options?: { forReviews?: boolean }
) {
  const titleText = computed(() => {
    if (options?.forReviews) {
      if (filters.role && (filters.city || filters.state)) {
        return 'Employee Insights by Location & Role'
      } else if (filters.city || filters.state) {
        return `Employee Insights in ${formatLocationForTitle({
          city: filters.city,
          state: filters.state
        })}`
      } else if (filters.role) {
        return `Insights from ${filters.role} Employees`
      }
      return `What is it like to work at ${companyName.value}?`
    } else {
      if (filters.role && (filters.city || filters.state)) {
        return `Average ${companyName.value} ${filters.role} Pay in ${locationDisplay.value}`
      }
      if (filters.role) {
        return `Average ${companyName.value} ${filters.role} Pay in the U.S.`
      }
      if (filters.city || filters.state) {
        return `Average ${companyName.value} Pay in ${locationDisplay.value}`
      }
      return `Average Salaries at ${companyName.value}`
    }
  })
  const filterDescription = computed(() => {
    if (!options?.forReviews) return ''
    const parts = []
    if (filters.role) {
      parts.push(`<strong>${filters.role}</strong>`)
    }
    if (filters.city) {
      parts.push(`in <strong>${filters.city}</strong>`)
      if (filters.state) {
        parts.push(`, <strong>${filters.state}</strong>`)
      }
    } else if (filters.state) {
      parts.push(`in <strong>${stateFullName.value}</strong>`)
    }
    return parts.length > 0 ? `Showing reviews for ${parts.join(' ')}` : ''
  })
  return {
    titleText,
    filterDescription
  }
}
